import React from "react";
import {
  Box, Typography, TextField, FormControl,
  InputLabel, Select, MenuItem, useTheme,
} from "@mui/material";
import moment     from "moment";
import PersonIcon from "@mui/icons-material/Person";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { currencyFormatter } from "utilities/currencyFormatter";

const InvoiceCreateView = ({ total, customers, handleChangeCustomer, customer }) => {
  const theme  = useTheme();
  const isDark = theme.palette.mode === "dark";

  const cardBg  = isDark ? "rgba(255,255,255,0.03)" : "#ffffff";
  const accent  = theme.palette.secondary.main;
  const textSec = theme.palette.neutral.main;
  const border  = isDark ? "rgba(29,158,117,0.14)" : "rgba(29,158,117,0.16)";

  const fieldSx = {
    "& .MuiInputBase-root": { fontSize: "13px", backgroundColor: isDark ? "rgba(255,255,255,0.03)" : "#fafafa", borderRadius: "8px" },
    "& .MuiOutlinedInput-notchedOutline": { borderColor: border },
    "& .MuiInputLabel-root": { fontSize: "13px" },
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "1.25rem" }}>

      {/* ── Invoice amount banner ── */}
      <Box sx={{
        display: "flex", alignItems: "center", gap: "10px",
        p: "1rem 1.25rem",
        backgroundColor: "rgba(29,158,117,0.06)",
        border: `1px solid ${border}`,
        borderRadius: "10px",
      }}>
        <Box sx={{ width: "34px", height: "34px", borderRadius: "9px", backgroundColor: "rgba(29,158,117,0.12)", display: "flex", alignItems: "center", justifyContent: "center", color: accent, flexShrink: 0 }}>
          <AttachMoneyIcon sx={{ fontSize: "18px" }} />
        </Box>
        <Box>
          <Typography sx={{ fontSize: "10px", fontWeight: 500, letterSpacing: "0.08em", textTransform: "uppercase", color: textSec }}>
            Invoice amount
          </Typography>
          <Typography sx={{ fontSize: "20px", fontWeight: 500, color: accent }}>
            {currencyFormatter(parseFloat(total))}
          </Typography>
        </Box>
      </Box>

      {/* ── Form fields ── */}
      <Box sx={{
        backgroundColor: cardBg,
        border: `1px solid ${border}`,
        borderRadius: "10px",
        overflow: "hidden",
      }}>
        <Box sx={{ px: "1.25rem", py: "0.75rem", borderBottom: `1px solid ${border}`, backgroundColor: isDark ? "rgba(29,158,117,0.05)" : "rgba(29,158,117,0.03)" }}>
          <Typography sx={{ fontSize: "10px", fontWeight: 500, letterSpacing: "0.08em", textTransform: "uppercase", color: accent }}>
            Invoice Details
          </Typography>
        </Box>

        <Box sx={{ p: "1.25rem", display: "flex", flexDirection: "column", gap: "1rem" }}>
          {/* Payment date */}
          <Box>
            <Typography sx={{ fontSize: "10px", fontWeight: 500, letterSpacing: "0.07em", textTransform: "uppercase", color: textSec, mb: "6px" }}>
              Expected date of payment
            </Typography>
            <TextField
              type="date"
              size="small"
              defaultValue={moment().format("YYYY-MM-DD")}
              fullWidth
              sx={fieldSx}
            />
          </Box>

          {/* Customer select */}
          <Box>
            <Typography sx={{ fontSize: "10px", fontWeight: 500, letterSpacing: "0.07em", textTransform: "uppercase", color: textSec, mb: "6px" }}>
              Attach customer to invoice
            </Typography>
            <FormControl fullWidth size="small" sx={fieldSx}>
              <InputLabel>Select a customer</InputLabel>
              <Select
                value={customer}
                label="Select a customer"
                onChange={handleChangeCustomer}
                startAdornment={
                  <PersonIcon sx={{ fontSize: "16px", color: textSec, mr: "6px", ml: "-4px" }} />
                }
              >
                {customers.map((c, i) => (
                  <MenuItem key={i} value={c.id}>
                    {`${c.related_user.first_name} ${c.related_user.last_name}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default InvoiceCreateView;